import { ALLOWED_CHARACTERS_REGEX, MAX_LENGTH_CHAR, MAX_FILE_SIZE_10MB, IMO_NUMBER_REGEX } from '@/common/constants';
import * as Yup from 'yup';

export const inspectionResultUploadSchema = Yup.object({
    /*reportName: Yup.string()
        .trim()
        .required('Report name is required')
        .max(50, 'Max length is 50 characters'),*/
    vesselName: Yup.string()
        .required('Vessel name is required')
        .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
        .max(MAX_LENGTH_CHAR, 'Max length is 50 characters'),
    imo: Yup.string()
        .required('IMO/Registation number is required')
        .matches(IMO_NUMBER_REGEX, 'IMO/Registration number must contain only alphabets, digits, dots, slashes, and dashes.')
        .max(20, 'Max length is 20 characters'),
    reportType: Yup.string()
        .trim()
        .required('Report type is required')
        .max(50, 'Max length is 50 characters'),
    sireResult: Yup.mixed()
        .test('fileSize', 'File size is too large', (value: any) => {
            if (value.size > MAX_FILE_SIZE_10MB) {
                return false;
            }

            return true;
        })
        .required('Result file is required')
});
